
<template>
  <div class="zc loginbody">
    <div class="main">
      <div class="new-register-box">
        <div class="coinbig-nasq">欢迎来到{{ APP_WINNY_NAME }}</div>
        <div class="codeTip">请使用微信扫码注册</div>
        <div class="popupQR">
          <vue-qr
            id="picture"
            class="qrcode"
            :text="registerUrl"
            :margin="3"
            color-dark="#000"
            color-light="#fff"
            :dot-scale="1"
            :size="400"
          ></vue-qr>
        </div>
        <div class="bottomRouter">
          <span class="loginTip">已有账号？</span>
          <span class="roLogin">
            <router-link tag="a" to="/login">登录</router-link>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import vueQr from 'vue-qr'

export default {
  name: 'Register',
  components: {
    vueQr
  },
  data() {
    return {
      registerUrl: window.g.REGISTER_URLS_CODE,
      APP_WINNY_NAME: window.g.APP_WINNY_NAME
    }
  }
}
</script>
<style scoped lang="scss">
@import '../../../assets/images/main.min.css';
@import '../../../assets/images/servicecenter.min.css';

.main {
  background-color: #fff;
  height: 100%;
  min-height: calc(100vh - 45px);
}

.qx span {
  color: #000000;
}

.new-register-box {
  background: #fff;
  opacity: .8;
  position: absolute;
  left: calc(50% - 250px);
  top: 10%;
  width: 400px;
  border-radius: 12px;

  .coinbig-nasq {
    font-size: 32px;
    text-align: left;
    font-family: PingFang SC;
    font-weight: 600;
    line-height: 45px;
    padding-top: 40px;
    color: #000000;
  }

  .popupQR {
    display: flex;
    justify-content: center;
    align-items: center;

  }

  .codeTip {
    margin-top: 40px;
    font-size: 20px;
    text-align: left;
    color: #000000;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    ;
  }

  .bottomRouter {
    margin: 40px auto;
    text-align: center;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
  }

  .roLogin a {
    font-size: 18px;
    color: #2382fa;
  }
}

.dialogBtn {
  // height: 40px;
  line-height: 40px;
  width: 40%;
}

.leftButton {
  float: left;
}</style>
<style>.qx span {
  color: #000000;
}

.loginbody {
  height: 100%;
  background-size: 100% 100%;
}
</style>
